import { useMediaQuery } from '@mui/material';
import Theme from '../theming/theme';

export const useScreenSizeProvider = (): { screenSize: 'SmallScreen' | 'LargeScreen' } => {
  const smallScreen = useMediaQuery(Theme.breakpoints.down('sm'), { noSsr: true });

  return { screenSize: smallScreen ? 'SmallScreen' : 'LargeScreen' };
};
